import React, {FC, useEffect} from 'react';
import {useAction} from "../../../../store/hooks/useAction";
import {useTypedSelector} from "../../../../store/hooks/useTypedSelector";
import QuickbetXLobbyComponent from "../Components/QuickbetXLobbyComponent";

interface STLProps {
    atagParams: string | null
    viewType?: string | null
    sourceParams: string | null,
    ticketOpenMode: string | null,
}
const QuickbetXLobby: FC <STLProps> = ({atagParams, viewType, sourceParams, ticketOpenMode}) => {
    const {getQuickbetsXData} = useAction();
    const {quickbetsXData} = useTypedSelector((state) => state.quickbetXsReducer);

    useEffect(()=>{
        getQuickbetsXData();
    }, [])
    return(
        <>
            {quickbetsXData.length > 0 ?
                <QuickbetXLobbyComponent
                    viewType={viewType}
                    data={quickbetsXData}
                    sourceParams={sourceParams}
                    ticketOpenMode={ticketOpenMode}
                    atagParams={atagParams}
                />
                : null
            }
        </>
    )

}

export default QuickbetXLobby;
